import loadable from '@loadable/component';
import LoadingPage from 'components/LoadingPage';

const LoadableAuthTestPage = loadable(() => import('./index'), {
  fallback: LoadingPage,
});

export default LoadableAuthTestPage;
